import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-request-loader',
  templateUrl: './member-request-loader.component.html',
  styleUrls: ['./member-request-loader.component.scss']
})
export class MemberRequestLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
